module.exports = __webpack_public_path__ + "img/AccuFFRangio_Series.f1323584.png";